import type { AxiosRequestConfig } from 'axios';
import { authed } from '../api';

/** Opciones comunes de todas las funciones de servicio. */
export interface RequestOpts {
  /** Cancela la petición (p. ej. al desmontar o al cambiar de filtros). */
  signal?: AbortSignal;
}

/** Config de axios para una ruta pública. */
export const pub = (opts?: RequestOpts): AxiosRequestConfig => ({ signal: opts?.signal });

/** Config de axios para una ruta privada (adjunta el Bearer y renueva la sesión ante un 401). */
export const priv = (opts?: RequestOpts): AxiosRequestConfig => authed({ signal: opts?.signal });

/** Parser de respuestas sin cuerpo (204/202): no valida nada. */
export const sinCuerpo = (): void => undefined;

/** Segmento de ruta seguro para un identificador que viene del usuario o del servidor. */
export const segmento = (id: string): string => encodeURIComponent(id);
